@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.graph {
  height: 192px;
  width: 100%;
}

.metricValues {
  display: flex;
  gap: 24px;
  align-items: center;

  @include for-phone-only {
    justify-content: space-between;
  }
}
